var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-field',{staticClass:"typo-roboto",attrs:{"label":_vm.$t('expiration.label')}},[_c('vca-selection',{attrs:{"selection":_vm.expirations},model:{value:(_vm.expiration),callback:function ($$v) {_vm.expiration=$$v},expression:"expiration"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }